function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "stack",
  d: "M8.408,6.514h9.844a.379.379,0,0,0,.379-.379V5.757A.757.757,0,0,0,17.873,5H8.786a.757.757,0,0,0-.757.757v.379a.379.379,0,0,0,.379.379M6.893,8.786H19.766a.379.379,0,0,0,.379-.379V8.029a.757.757,0,0,0-.757-.757H7.272a.757.757,0,0,0-.757.757v.379a.379.379,0,0,0,.379.379m14.766,1.893v9.844a1.137,1.137,0,0,1-1.136,1.136H6.136A1.137,1.137,0,0,1,5,20.523V10.679A1.137,1.137,0,0,1,6.136,9.543H20.523a1.137,1.137,0,0,1,1.136,1.136",
  transform: "translate(-5 -5)",
  fill: "#fff"
});

function SvgIcHabitStatusActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.659,
    height: 16.659,
    viewBox: "0 0 16.659 16.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitStatusActive);
export default ForwardRef;